/**
* Created by lobin on 2020/8/11.
*/
<template>
	<div class="recharge">
		<a-card :body-style="{padding: '40px 32px'}" :bordered="false">
			<div style="width: 50%;margin: 0 auto;">
				<a-steps :current="current">
					<a-step v-for="item in steps" :key="item.title" :title="item.title" />
				</a-steps>
				<div v-show="current === 0">
					<a-radio-group style="padding-top: 20px;padding-left: 20px" v-model="balance">
						<a-row :gutter="20">
							<a-col :span="8" v-for="item in rechargeList" :key="item" style="line-height: 3">
								<a-radio :value="item">充值{{ item }}元</a-radio>
							</a-col>
						</a-row>
					</a-radio-group>
					<a-input-number v-model="manuBalance" placeholder="输入自定义金额" v-if="balance === '其他金额'" style="width:100%" :step="10" :min="50" />
				</div>
				<div v-show="current === 1" style="text-align: center;padding-top: 20px">
					<a-alert :message="payConfig.payTitle" type="warning"></a-alert>
					<canvas id="qrcodeImg" style="padding: 10px;margin-top:20px;border: 1px solid #aaa"></canvas>
				</div>
				<div v-show="current === 2">
					<a-result
						:status="payResult.isPay ? 'success' : 'error'"
						:title="payResult.isPay ? '支付成功' : '支付失败'"
						:sub-title="payResult.isPay ? '支付成功' : '支付失败'"
					>
					</a-result>
				</div>
			</div>
			<div style="text-align: center;margin-top: 20px;padding: 20px 0;">
				<a-button key="back" @click="handleCancel" v-if="btnText.pre" style="margin-right: 20px;">{{ btnText.pre }}</a-button>
				<a-button key="submit" type="primary" :loading="loading" @click="handleOk" v-if="btnText.nex">{{ btnText.nex }}</a-button>
			</div>
		</a-card>
	</div>
</template>

<script type="text/babel">
import QRCode from 'qrcode';
import {
  getComapnyRechargeQrcode,
  getComapnyRechargeDetail,
} from '@/api/company';

export default {
  data() {
    return {
	    current: 0,
	    steps: [
		    {
			    title: '选择充值金额',
			    content: 'First-content',
		    },
		    {
			    title: '扫码支付',
			    content: 'Second-content',
		    },
		    {
			    title: '支付结果',
			    content: 'Last-content',
		    },
	    ],
	    rechargeList: [200, 300, 400, 500, 1000, '其他金额'],
	    balance: 200,
		manuBalance: '',
	    id: '',
	    loading: false,
	    payConfig: {},
	    payResult: {},
    };
  },
  created() {
  	this.id = this.$route.params.id;
  },
  computed: {
	  btnText() {
		  const { current } = this;
		  if (current === 0) {
			  return {
				  pre: '',
				  nex: '下一步',
			  };
		  }
		  if (current === 1) {
			  return {
				  pre: '重新选择',
				  nex: '下一步',
			  };
		  }
		  if (current === 2) {
			  if (this.payResult.isPay) {
				  return {
					  pre: '',
					  nex: '确定',
				  };
			  }
			  return {
				  pre: '',
				  nex: '重新查询',
			  };
		  }
		  return {};
	  },
  },
  methods: {
	  createQrcode(text) {
		  const canvas = document.getElementById('qrcodeImg');
		  console.log(canvas);
		  // const that = this;
		  QRCode.toCanvas(
			  canvas,
			  text,
			  {
				  errorCorrectionLevel: 'H',
				  margin: 1,
				  width: 200,
				  color: {
					  dark: '#000',
					  light: '#fff',
				  },
			  },
			  (err) => {
				  if (err) console.error(err);
				  // that.createPoster();
			  },
		  );
	  },
	  handleCancel() {
		  this.current -= 1;
	  },
	  async handleOk() {
		  if (this.current === 0) {
			  await this.getPayUrl();
			  this.createQrcode(this.payConfig.url);
			  this.current += 1;
			  return;
		  }
		  if (this.current === 1) {
			  await this.getPayResult();
			  this.current += 1;
		  }
		  if (this.current === 2) {
			  if (this.payResult.isPay) {
				  this.$router.go(-1);
			  } else {
				  await this.getPayResult();
			  }
		  }
	  },
	  async getPayUrl() {
		  this.loading = true;
		  const { data } = await getComapnyRechargeQrcode(this.id, this.balance === '其他金额' ? this.manuBalance : this.balance);
		  this.payConfig = data;
		  this.loading = false;
	  },
	  async getPayResult() {
		  this.loading = true;
		  const { data } = await getComapnyRechargeDetail(this.payConfig.orderId);
		  this.payResult = data;
		  this.loading = false;
	  },
  },
};
</script>

<style lang="less" rel="stylesheet/less">
	.recharge {

	}
</style>
